export const SpeedTest = async () => {
  const testFileUrl =
    "https://v4dstorage.blob.core.windows.net/demo/projetos/SpeedTest/test/2025-01-01/DJI_0615.jpg";
  const startTime = performance.now();

  try {
    const response = await fetch(testFileUrl, { cache: "no-cache" });
    const blob = await response.blob();

    const endTime = performance.now();
    const duration = (endTime - startTime) / 1000;

    const bitsLoaded = blob.size * 8;
    const speedBps = bitsLoaded / duration;
    const speedMbps = speedBps / (1024 * 1024);

    return speedMbps;
  } catch (error) {
    console.error("Speed test failed:", error);
    return 1;
  }
};
